<template>

  <div>

    <b-card no-body>
      <b-card-body>
        <span>
          This page will import (or trigger update) for an existing profile on the provisioning platform.
          Note all fields are required in the import file, see FILE FORMAT.
        </span>
        <p>&nbsp;</p>
        <b-row>
          <b-col xl="6" lg="8" md="7" class="pb-2">
            <div class="input-group">
              <b-input-group>
                <template #prepend>
                  <b-input-group-text class="bg-primary text-white file-upload-width">Upload File</b-input-group-text>
                </template>
                <div class="mt-2 px-2 border-info">
                  <b-form-file
                      size="md"
                      v-model="importFile"
                      accept=".csv,.xls,.xlsx"
                      @change="onLoadFileData($event)"
                      class="w-100 browser-button"
                      plain>
                  </b-form-file>

                </div>
              </b-input-group>
            </div>
          </b-col>
          <b-col xl="6" lg="4" md="5">
            <div class="input-group">
              <b-input-group>

                <vue-json-to-csv
                    :json-data="template_data" :csv-title="exportDataTitle">
                  <b-button
                      type="button"
                      variant="info"
                      title="Download a CSV template example"
                      v-b-tooltip.hover
                  >Download <i class="fa fa-download" aria-hidden="true"></i>
                  </b-button>
                </vue-json-to-csv>
                &nbsp;
                <b-button
                    type="button"
                    variant="danger"
                    v-on:click="processBatchImport"
                    :disabled="!showPreviewData"
                    title="Upload your data to the server"
                    v-b-tooltip.hover
                >Upload <i class="fa fa-upload" aria-hidden="true"></i>
                </b-button>
              </b-input-group>
            </div>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <div v-if="showPreviewData">
      <b-row>
        <b-col xl="8" lg="8" md="8" sm="5">
          <b-form-group
              label=""
              label-for="per-page-select"
              label-cols-sm="0"
              label-cols-md="0"
              label-cols-lg="0"
              label-align-sm="center"
              label-size="sm"
              class="mb-2 d-flex"
          >
            <label for="per-page-select" class="mr-2 text-sm mt-1">Show</label>
            <b-form-select
                id="per-page-select"
                class="custom-table-entries"
                v-model="perPage"
                :options="pageOptions"
                v-on:input="changePageOption(perPage)"
                size="sm"
            ></b-form-select>
            <label for="per-page-select" class="ml-2 text-sm mt-1">entries</label>
          </b-form-group>
        </b-col>
        <b-col xl="4" lg="4" md="4" sm="7" class="customer-table-select">
          <b-form-group
              label=""
              label-for="filter-input"
              label-align-sm="right"
              label-size="sm "
              class="mb-0 d-flex search-input"
          >
            <label for="filter-input" class="text-sm mr-2 mt-1">Search:</label>
            <b-input-group size="sm">
              <b-form-input
                  id="filter-input"
                  v-model="filter"
                  class="mb-4"
              ></b-form-input>

            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-table
          striped hover
          :items="preview_items"
          :fields="newColumn"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          :filter-included-fields="filterOn"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          head-variant="light"
          table-class="text-nowrap"
          class="primary-table"
          sticky-header="true"
          show-empty
          responsive
          small
          @filtered="onFiltered"
          :tbody-tr-class="rowClass"
      >
        <template slot="empty">
          <div class="text-center text-danger" v-if="isBusy">
            processing uploaded data...
            <i  class="fas fa-spinner fa-spin">  </i>
          </div>
          <div v-else class="text-center">
            No rows to display!
          </div>
        </template>
        <template #cell(action)="row">
           <span>
             <i class="fas fa-pen-nib mr-3 cursor-pointer text-success" v-b-modal.change-group
                v-on:click="changeGroupFunc(row.item.userName, row.item.group)"></i>
             <i class="fas fa-trash-alt cursor-pointer  text-danger" v-on:click="deleteUserInfo(row.item.userName)"></i>
           </span>
        </template>
      </b-table>
      <b-row class="mt-4">
        <b-col>
          <p class="ml-3 nowrap">{{ startPage() }} - {{ lastPage() }} of {{ totalRows }}</p>
        </b-col>
        <b-col>
          <b-pagination
              class="flex-fill-custom pr-4 ml-3 justify-content-end"
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              size="sm"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>

    <b-modal centered size="lg" id="import-detail" hide-footer title="Import Detail" class="import-detail"
             cancel-title="Close" ok-variant="primary" ok-title="Submit">
      <ImportDetail></ImportDetail>
    </b-modal>

  </div>
</template>

<script>
import VueJsonToCsv from 'vue-json-to-csv'
import administratorService from "../../../../common/api-services/administrator-service";
import ImportDetail from "../../../Components/Import-Detail";
import * as XLSX from "xlsx";
import commonService from "@/common/api-services/common";
import pagination from '../../../../common/format/pagination'

export default {
  name: "LoadSims",
  components: {ImportDetail, VueJsonToCsv},
  data() {
    return {
      csvFile: null,
      file: null,
      importFile: null,
      arrayBuffer: null,
      fileInfo: [],
      groupOption: [],
      showPreviewData: false,
      isBusy: false,
      totalRows: 0,
      currentPage: 1,
      pageOptions: [10, 25, 50, 100],
      perPage: 10,
      tableColumns: [
        {key: 'ICCID', label: 'ICCID', sortable: true, sortDirection: 'desc'},
        {key: 'PIN1', label: 'Pin1', sortable: true, sortDirection: 'desc'},
        {key: 'PIN2', label: 'Pin2', sortable: true, sortDirection: 'desc'},
        {key: 'PUK1', label: 'Puk1', sortable: true, sortDirection: 'desc'},
        {key: 'PUK2', label: 'Puk2', sortable: true, sortDirection: 'desc'},
        {key: 'kid', label: 'Kid', sortable: true, sortDirection: 'desc'},
        {key: 'operator', label: 'Operator', sortable: true, sortDirection: 'desc'},
        {key: 'Ki', label: 'Ki', sortable: true, sortDirection: 'desc'},
        {key: 'IMSI', label: 'IMSI', sortable: true, sortDirection: 'desc'},
        {key: 'opc', label: 'Opc', sortable: true, sortDirection: 'desc'},
        {key: 'MSISDN', label: 'MSISDN', sortable: true, sortDirection: 'desc'},
        {key: 'customer', label: 'Customer', sortable: true, sortDirection: 'desc'},
        {key: 'status', label: 'Status', sortable: true, sortDirection: 'desc'},
        {key: 'product', label: 'Product', sortable: true, sortDirection: 'desc'},
        {key: 'simtype', label: 'SimType', sortable: true, sortDirection: 'desc'},
      ],
      importData: [],
      preview_items: [],
      localData: [],
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      tableHeaderforBody: [],
      exportDataTitle: 'inventory_template.csv',
      template_data: [{
        "ICCID": "99999999999999999999",
        "IMSI": "999990000100009",
        "MSISDN": "12223334444",
        "PIN1": "",
        "PIN2": "",
        "PUK1": "TEST_PUK1",
        "PUK2": "TEST_PUK2",
        "kid": "TEST_KID",
        "operator": "",
        "Ki": "",
        "opc": "",
        "customer": "",
        "product": "",
        "simtype": ""
      }],
      importStatus: [],
      newColumn: []
    }
  },
  mounted() {

  },
  methods: {

     rowClass(item, type) {
      if (!item ) return;
      if (type !== 'row') return 'table-info';
      if (JSON.stringify(item).includes('INVALID')) return 'table-danger';
      return;
    },

    //validate file format and headers
    //https://docs.sheetjs.com/docs/api/utilities
    async onLoadFileData(event) {
      this.showPreviewData = true;
      this.isBusy = true;
      this.file = event.target.files[0];
      if (this.file) {
        let fileReader = new FileReader();
        fileReader.readAsArrayBuffer(this.file);
        fileReader.onload = e => {
          this.arrayBuffer = fileReader.result;
          let data = new Uint8Array(this.arrayBuffer);
          let arr = new Array();
          for (let i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
          let bstr = arr.join("");
          let wb = XLSX.read(bstr, {type: "binary"});
          let first_sheet_name = wb.SheetNames[0];
          let ws = wb.Sheets[first_sheet_name];
          let arraylist = XLSX.utils.sheet_to_json(ws, {raw: false});
          this.importData = arraylist;
          this.importDataLength = arraylist.length;
          this.loadPreviewData();
        };
      } else {
        this.showPreviewData = false;
      }
    },

    async loadPreviewData() {
      this.preview_items = [];
      let data = this.importData;//.slice(0, 2);
      Object.keys(data).forEach(idx => {
        this.formatDataRow(data[idx]).then(row => {
          this.preview_items.push(row[0]);
          this.getTotalRows();
        });
      });

      if (JSON.stringify(this.preview_items).includes('INVALID')) {
        this.$toast.error('Errors were identified in the import data. Please review your dataset below.')
      }
      this.isBusy = false;
    },

    //format the data...
    async formatDataRow(data_in) {
      let data_out = [];
      data_in = commonService.InventoryMapImportKeys(data_in);
      Object.keys(data_in).forEach(field => {
        if (!commonService.validateData(field, data_in[field])) {
          data_in[field] = '!!INVALID!!' + data_in[field];
        }
      });
      data_out.push(data_in);
      return data_out;
    },

    async processBatchImport() {
      this.importStatus = [];

      this.$bvModal.show('import-detail');
      for(let i = 0; i < this.importData.length; i ++){
        let item = this.importData[i];
        await new Promise((resolve, reject) => {
          this.formatDataRow(item).then(row => {
            administratorService.importTemplate(row[0]).then(res => {
              if (res !== null) {
                let responseMsg = '';
                if (Array.isArray(res)) {
                  responseMsg = res.join('<br/>');
                } else {
                  responseMsg = res
                }
                if (res.indexOf('FAIL') !== -1 || responseMsg.indexOf('Error') !== -1) {
                  this.importStatus.push({
                    status: false,
                    id: Number(row[0]['IMSI']).toString(),
                    message: responseMsg
                  })
                } else {
                  this.importStatus.push({
                    status: true,
                    id: Number(row[0]['IMSI']).toString(),
                    message: responseMsg
                  })
                }
              }
              setTimeout(() => {
                this.$root.$emit('import-detail', this.importStatus);
                resolve();
              }, 200)
            });
          });
        })
       
      }
      setTimeout(() => {
        this.$toast.success('Import Complete!')
      }, 1000)
    },
    changePageOption(page) {
      this.perPage = page;
      this.lastPage()
    },

    getTotalRows() {
      this.totalRows = this.preview_items.length
    },
    startPage() {
      return pagination.startPageFunc(this.currentPage, this.perPage)
    },
    lastPage() {
      return pagination.lastPageFunc(this.currentPage, this.perPage, this.totalRows)
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  }
}
</script>
